<template>
  <div
    class="tagListBox"
    v-loading="loading"
    :element-loading-text="$t('lang.k_352001')"
    element-loading-background="rgba(255,255,255,.9)"
    v-if="!loading"
  >
    <pageTitle :pageTitle="$t('lang.k_352002')">
      <div slot="content">
        {{ $t('lang.k_352003') }}
        <br />
        {{ $t('lang.k_352004') }}
        <br />
      </div>
    </pageTitle>
    <span v-if="!nullDate">
      <!-- 操作栏  -->
      <div class="operaBox">
        <vh-button
          type="primary"
          round
          @click="create"
          v-preventReClick
          size="medium"
          class="length104"
        >
          {{ $t('lang.k_352005') }}
        </vh-button>
        <vh-button
          size="medium"
          round
          @click="remove"
          plain
          :disabled="!checkList.length"
          class="transparent-btn"
          v-preventReClick
        >
          {{ $t('lang.k_352006') }}
        </vh-button>
        <vh-button type="text" size="medium" @click="reset" v-preventReClick class="text_button">
          {{ $t('lang.k_352007') }}
        </vh-button>
        <div class="searchBox">
          <vh-input
            class="search-tag"
            :placeholder="$t('lang.k_352008')"
            v-model="searchName"
            clearable
            round
            @change="searchHandler()"
          >
            <i class="vh-icon-search vh-input__icon" slot="prefix"></i>
          </vh-input>
        </div>
      </div>
      <div class="word-list">
        <table-list
          ref="tableListWord"
          :manageTableData="tableList"
          :tabelColumnLabel="tableColumn"
          :tableRowBtnFun="tableRowBtnFun"
          :totalNum="totalNum"
          :pageLimit="query.limit"
          max-height="auto"
          width="194"
          @onHandleBtnClick="onHandleBtnClick"
          @getTableList="searchHandler"
          @changeTableCheckbox="changeTableCheckbox"
        ></table-list>
        <null-page :text="$t('lang.k_352009')" nullType="search" v-if="totalNum === 0"></null-page>
      </div>
    </span>
    <div v-if="nullDate">
      <null-page :text="$t('lang.k_352010')" nullType="button">
        <vh-button
          type="primary"
          round
          @click="create"
          v-preventReClick
          size="medium"
          class="create_but"
        >
          {{ $t('lang.k_352005') }}
        </vh-button>
      </null-page>
    </div>

    <!-- 创建标签弹框 -->
    <VhallDialog
      :title="title"
      :visible.sync="createDialog"
      top="20vh"
      class="zdy-async-dialog"
      width="400px"
    >
      <div class="async__body">
        <div class="async__ctx">
          <vh-input
            :placeholder="$t('lang.k_352008')"
            v-model="keyWords"
            v-clearEmoij
            show-word-limit
            :maxlength="15"
          ></vh-input>
        </div>
        <div class="async__footer">
          <vh-button type="info" size="medium" @click="unSureAsyncHandle" plain round>
            {{ $t('lang.k_352011') }}
          </vh-button>
          <vh-button type="primary" size="medium" v-preventReClick @click="sureAsyncHandle" round>
            {{ $t('lang.k_352012') }}
          </vh-button>
        </div>
      </div>
    </VhallDialog>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle';
  import NullPage from '@/views/PlatformModule/Error/nullPage.vue';
  import { sessionOrLocal } from '@/utils/utils';
  export default {
    data() {
      return {
        loading: false,
        tableList: [],
        tableColumn: [
          {
            label: this.$t('lang.k_352013'),
            key: 'name',
            width: 'auto',
            customTooltip: true
          },
          {
            label: this.$t('lang.k_352014'),
            key: 'created_at',
            width: 200
          },
          {
            label: this.$t('lang.k_352015'),
            key: 'updated_at',
            width: 200
          },
          {
            label: this.$t('lang.k_352016'),
            key: 'isQuote',
            width: 120
          }
        ],

        tableRowBtnFun: [
          {
            name: this.$t('lang.k_352017'),
            methodName: 'setTop',
            disabledKey: 'is_order_one'
          },
          {
            name: this.$t('lang.k_352018'),
            methodName: 'editItem'
          },
          {
            name: this.$t('lang.k_352019'),
            methodName: 'deleteHandle'
          }
        ],

        query: {
          pos: 0,
          limit: 10,
          pageNumber: 1
        },
        totalNum: 0,
        keyWords: '',
        searchName: '',
        checkList: [],
        nullDate: false,
        createDialog: false,
        status: 'new', // 操作状态
        selectId: '', // 编辑数据id
        title: ''
      };
    },
    computed: {},
    components: {
      PageTitle,
      NullPage
    },
    mounted() {
      this.searchHandler();
    },
    beforeDestroy() {
      if (this.lowerGradeInterval) clearInterval(this.lowerGradeInterval);
    },
    methods: {
      // 创建标签
      create() {
        if (this.totalNum >= 1000) {
          this.$vhMessage.warning(this.$t('lang.k_352020'));
          return false;
        }
        this.status = 'new';
        this.title = this.$t('lang.k_352021');
        this.createDialog = true;
      },
      //   重置排序
      reset() {
        this.$fetch('labelResetOrder', {}).then(res => {
          if (res.code == 200) {
            this.searchHandler();
            this.$vhMessage({
              message: `${this.$t('lang.k_352022')}`,
              showClose: true,
              type: 'success',
              customClass: 'zdy-info-box'
            });
          }
        });
      },
      // 搜索
      searchHandler(row) {
        if (typeof row == 'object') {
          this.query.pos = row.pos;
          this.query.pageNumber = row.pageNum;
          this.query.limit = row.limit;
        } else {
          this.query.pos = 0;
          if (this.totalNum > 10) {
            this.$refs.tableListWord.pageInfo.pageNum = 1;
          }
        }
        this.$fetch('labelList', {
          name: this.searchName,
          pos: this.query.pos,
          limit: this.query.limit
        }).then(res => {
          if (res.code == 200) {
            if (!this.searchName && res.data.total == 0) {
              this.nullDate = true;
            } else {
              this.nullDate = false;
            }
            this.tableList = res.data.list;
            this.totalNum = res.data.total;
            if (this.tableList.length == 0 && this.query.pos > 0) {
              this.searchHandler({
                pos: this.query.pos - 10
              });
            }
            this.tableList.forEach((item, ind) => {
              item.isQuote = item.is_quote ? this.$t('lang.k_352023') : this.$t('lang.k_352024');
              if (ind == 0 && this.query.pos == 0) {
                item.is_order_one = true;
              }
            });
          }
        });
      },
      //
      onHandleBtnClick(val) {
        console.log(this.$options.methods, val, 'onHandleBtnClick');
        let methodsCombin = this.$options.methods;
        methodsCombin[val.type](this, val);
      },
      // 选中数据
      changeTableCheckbox(val) {
        console.log(val, 'changeTableCheckbox');
        this.checkList = val;
      },
      // 置顶
      setTop(that, row) {
        that
          .$fetch('labelTop', {
            label_id: row.rows.label_id
          })
          .then(res => {
            if (res.code == 200) {
              that.searchHandler();
              that.$vhMessage({
                message: `${that.$t('lang.k_352025')}`,
                showClose: true,
                type: 'success',
                customClass: 'zdy-info-box'
              });
            }
          });
        console.log(row, 'setTop');
      },
      // 编辑前获取详情
      editItem(that, row) {
        that.status = 'edit';
        that.selectId = row.rows.label_id;
        that.createDialog = true;
        that.title = that.$t('lang.k_352018');
        that.keyWords = row.rows.name;
      },
      // 删除
      deleteHandle(that, row, arr) {
        if (row && row.rows.is_quote) {
          that.$vhConfirm(that.$t('lang.k_352026'), that.$t('lang.k_352027'), {
            confirmButtonText: that.$t('lang.k_352028'),
            customClass: 'zdy-message-box',
            lockScroll: false,
            showCancelButton: false,
            closeOnClickModal: false,
            roundButton: true,
            closeOnPressEscape: false,
            cancelButtonClass: 'zdy-confirm-cancel'
          });
          return false;
        }
        /* prettier-ignore */
        that.$vhConfirm(that.$t('lang.k_352029'), that.$t('lang.k_352027'), {
            confirmButtonText: that.$t('lang.k_352030'),
            cancelButtonText: that.$t('lang.k_352031'),
            customClass: 'zdy-message-box',
            lockScroll: false,
            closeOnClickModal: false,
            roundButton: true,
            closeOnPressEscape: false,
            cancelButtonClass: 'zdy-confirm-cancel'
          })
          .then(() => {
            let label_ids = '';
            let arr_ids = [];
            if (row) {
              label_ids = row.rows.label_id;
            } else {
              that.checkList.forEach(item => {
                arr_ids.push(item.label_id);
                label_ids = arr_ids.join(',');
              });
            }
            console.log(label_ids, 'label_ids');
            that.$fetch('labelDelete', { label_ids})
              .then(res => {
                if (res.code == 200) {
                  that.searchHandler();
                  that.$vhMessage({
                    message: `${that.$t('lang.k_352032')}`,
                    showClose: true,
                    type: 'success',
                    customClass: 'zdy-info-box'
                  });
                }
              })
              .catch(err => {
                if (err.code == 512079) {
                  that.$vhMessage({
                    message: err.msg,
                    showClose: true,
                    type: 'warning',
                    customClass: 'zdy-info-box'
                  });
                }
              });
          })
          .catch();
      },
      //   批量删除
      remove() {
        this.deleteHandle(this, false, this.checkList);
      },
      // 创建保存
      sureAsyncHandle() {
        let api = '';
        let params = {
          name: this.keyWords
        };
        let tip;
        if (this.status == 'new') {
          api = 'labelCreate';
          tip = this.$t('lang.k_352033');
        } else {
          api = 'labelEdit';
          tip = this.$t('lang.k_352034');
          params.label_id = this.selectId;
        }
        let http = () =>
          this.$fetch(api, params)
            .then(res => {
              if (res.code == 200) {
                this.$vhMessage.success(tip);
                this.unSureAsyncHandle();
                this.searchHandler();
              } else {
                this.$vhMessage.error(err?.msg);
              }
            })
            .catch(err => {
              this.$vhMessage.warning(err.msg);
            });
        if (this.status == 'new') {
          http();
        } else {
          this.$vhConfirm(this.$t('lang.k_352035'), this.$t('lang.k_352027'), {
            confirmButtonText: this.$t('lang.k_352030'),
            cancelButtonText: this.$t('lang.k_352031'),
            customClass: 'zdy-message-box',
            lockScroll: false,
            closeOnClickModal: false,
            roundButton: true,

            closeOnPressEscape: false,
            cancelButtonClass: 'zdy-confirm-cancel'
          })
            .then(() => {
              http();
            })
            .catch(() => {});
        }
      },
      // 创建取消
      unSureAsyncHandle() {
        this.createDialog = false;
        this.keyWords = '';
      }
    }
  };
</script>
<style lang="less">
  .tagListBox {
    .pageTitle {
      color: #1a1a1a;
      font-size: 22px;
      font-weight: 600;
    }
    .operaBox {
      overflow: hidden;
      margin-top: 12px;
      margin-bottom: 20px;
      .text_button {
        color: #3562fa;
        padding: 0;
      }
      .searchBox {
        float: right;
      }
    }
    .word-list {
      width: 100%;
      .layout--right--main();
      .padding-table-list();
    }
    .create_but {
      padding: 6px 41px !important;
    }
    .zdy-async-dialog {
      top: 20vh;
      .async__footer {
        padding-bottom: 0;
      }
    }
  }
</style>
